import React from "react";
import CPLCampaignsTable from "./CPLCampaignsTable";

interface StatisticsTabProps {
  creatorId: string;
}

/**
 * StatisticsTab Component
 *
 * Displays CPL Orders (campaigns) for the creator.
 * Uses the new CPLCampaignsTable based on onlyu_front structure.
 */
const StatisticsTab: React.FC<StatisticsTabProps> = ({ creatorId }) => {
  return (
    <div className="space-y-4">
      <CPLCampaignsTable creatorId={creatorId} />
    </div>
  );
};

export default StatisticsTab;
